var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { ModalContent } from '@amzn/atoz-web/Modal';
import { ButtonVariant } from '@amzn/atoz-web/Button';
import { LoadingButton } from '../../shared';
import { SpinnerColorScheme } from '@amzn/atoz-web/Spinner';
import { Text } from '@amzn/atoz-web/Text';
import { useTranslation } from 'react-i18next';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { MessageBanner, MessageBannerType } from '@amzn/atoz-web/MessageBanner';
export var LegacyCancelSwapRequestModalContent = function (_a) {
    var close = _a.close, onSubmit = _a.onSubmit, isSubmitting = _a.isSubmitting, swapFromDate = _a.swapFromDate, _b = _a.hasMultipleShifts, hasMultipleShifts = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    var swapFromDateString = swapFromDate.toLocaleString({
        weekday: 'short',
        day: 'numeric',
        month: 'short'
    });
    return (React.createElement(ModalContent, { dataTestId: "LegacyCancelSwapRequestModalContent", titleText: t('shift_management_features_CancelSwapRequestModal_title'), buttons: [
            React.createElement(StyledLoadingButton, { loading: isSubmitting, key: "cancelButton", ariaLabel: t('shift_management_features_CancelSwapRequestModal_confirmButton'), altText: t('shift_management_common_button', {
                    label: t('shift_management_features_CancelSwapRequestModal_confirmButton')
                }), dataTestId: "CancelSwapRequestModalContent_cancelButton", onClick: onSubmit, spinnerColor: SpinnerColorScheme.Inverted, buttonVariant: ButtonVariant.Primary, buttonText: t('shift_management_features_CancelSwapRequestModal_confirmButton') })
        ], onCloseButtonClick: close, closeButtonAltText: t('shift_management_common_closeModalButton') },
        hasMultipleShifts && (React.createElement(MessageBanner, { dataTestId: "CancelSwapRequestModalContent_multipleShiftBanner", type: MessageBannerType.Warning },
            React.createElement(Text, null, t('shift_management_features_CancelSwapRequestModal_multipleShiftBanner', { swapFromDate: swapFromDateString })))),
        React.createElement(Text, null, t('shift_management_features_CancelSwapRequestModal_body'))));
};
var StyledLoadingButton = styledWithTheme(LoadingButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n"], ["\n    width: 100%;\n"])));
var templateObject_1;
